import { MatSnackBarConfig } from '@angular/material/snack-bar';

export const ALERTS_CONFIG : MatSnackBarConfig  = {
    duration: 3000,
    verticalPosition: 'top',
    horizontalPosition: 'center',
}